/*
  学習サイトのコース数とレッスン数。HP・30日 LP・広告 LP・/lp/prod-dev がすべてここを読む。数が変わるときはここだけ直す。
  数え方は、受講生が学習サイトの /learn/courses で見る一覧と同じ (UNLISTED_COURSE_SLUGS で一覧から外したコースは数えない)。
  2026年10月12日に本番の /learn/courses の見出し (11学習分野・81コース・1,701レッスン) と照らして直した。
  以前の 116 コース・2,455 レッスンは、一覧から外した 35 コースも含む数で、受講生の画面とは合わなかった
*/
export const COURSE_COUNT = 81;
export const LESSON_COUNT = 1701;
export const SCHOOL_STATS_AS_OF = "2026年10月時点";

/* 画面に出す字 (3桁区切り)。Intl に頼らず、書き出しのビルドと手元で同じ字になるようにする */
const withCommas = (n: number) => String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
export const COURSE_COUNT_TEXT = withCommas(COURSE_COUNT);
export const LESSON_COUNT_TEXT = withCommas(LESSON_COUNT);

/*
  授業アーカイブ (過去のライブ授業の録画) の本数と時間。学習画面の「授業アーカイブ」の表示を 2026年10月4日に数えた値 (ログインした画面にしか出ないので、その後は数え直していない)。
  アーカイブは授業のたびに増えるので、画面には「以上」を付けて出す。数え直したらここだけ直す
*/
export const LESSON_ARCHIVE_COUNT = 71;
export const LESSON_ARCHIVE_HOURS = 142;
